/*
    0 = Fusión (internet, fijo, televisión y líneas móviles).
    1 = Trío (internet, fijo y televisión).
    2 = Dúo (internet y televisión).
    3 = Sólo línea móvil.
    4 = Sólo terminal.
*/
export default {
  FUSION: 0,
  TRIO: 1,
  DUO: 2,
  ONLY_MOBILE_LINE: 3,
  ONLY_TERMINAL: 4,
};
